import { DOMOutputSpecArray, MarkSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class StrongMark implements MarkSpec {
  public static readonly markName = MarkName.Strong;
  public parseDOM = [
    { tag: 'strong' },
    // This works around a Google Docs misbehavior where
    // pasted content will be inexplicably wrapped in `<b>`
    // tags with a font-weight normal.
    { tag: 'b', getAttrs: (node: HTMLElement) => node.style.fontWeight !== 'normal' && null },
    {
      style: 'font-weight',
      getAttrs: (value: string) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
    },
  ];

  public toDOM(): DOMOutputSpecArray {
    return ['strong', 0];
  }
}

export type BoldSchema = RtSchemaType<any, typeof StrongMark>;
